/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CheckRun } from './CheckRun';
import {
    CheckRunFromJSON,
    CheckRunFromJSONTyped,
    CheckRunToJSON,
    CheckRunToJSONTyped,
} from './CheckRun';

/**
 * Derived screener decision for a lead. Combines pre-screen audit rows and `screener_suggestion` (LeadAnalyzer output, surfaced as a synthetic `analyzer` check). Populated by lead-read endpoints that load the underlying inputs (`leadsFindOne`, `leadsFindAll`); other lead-read paths may omit this field.
 * @export
 * @interface EffectiveDecision
 */
export interface EffectiveDecision {
    /**
     * 
     */
    decision: EffectiveDecisionDecisionEnum;
    /**
     * One entry per check that has produced a verdict (latest write per check name, plus a synthetic `analyzer` check derived from `screener_suggestion` when set, including terminal `Cancelled` / `N/A` states). Consumers can derive the driving check by walking this array.
     */
    checks: Array<CheckRun>;
}


/**
 * @export
 */
export const EffectiveDecisionDecisionEnum = {
    Accept: 'Accept',
    Reject: 'Reject',
    Maybe: 'Maybe',
    Pending: 'Pending',
    Cancelled: 'Cancelled',
    NA: 'N/A',
} as const;
export type EffectiveDecisionDecisionEnum = typeof EffectiveDecisionDecisionEnum[keyof typeof EffectiveDecisionDecisionEnum];


/**
 * Check if a given object implements the EffectiveDecision interface.
 */
export function instanceOfEffectiveDecision(value: object): value is EffectiveDecision {
    if (!('decision' in value) || value['decision'] === undefined) return false;
    if (!('checks' in value) || value['checks'] === undefined) return false;
    return true;
}

export function EffectiveDecisionFromJSON(json: any): EffectiveDecision {
    return EffectiveDecisionFromJSONTyped(json, false);
}

export function EffectiveDecisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EffectiveDecision {
    if (json == null) {
        return json;
    }
    return {
        
        'decision': json['decision'],
        'checks': ((json['checks'] as Array<any>).map(CheckRunFromJSON)),
    };
}

export function EffectiveDecisionToJSON(json: any): EffectiveDecision {
    return EffectiveDecisionToJSONTyped(json, false);
}

export function EffectiveDecisionToJSONTyped(value?: EffectiveDecision | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'decision': value['decision'],
        'checks': ((value['checks'] as Array<any>).map(CheckRunToJSON)),
    };
}

